// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1IlE9","notes":"Notes_notes__1DRT-"};